import React from "react";
import '../../styles/bgs.css';

export default function SupportedTech() {
  return (
    <div className="w-full h-full mx-auto bg-supported-tech">
      <div className="w-full flex justify-center items-center max-w-full xl:w-[1920px] mx-auto ">
        
        <div className="flex flex-col justify-center items-center">
          <div className="w-full max-w-[320px] lg:max-w-full lg:w-96 flex-col justify-center items-center gap-5 flex flex-col mt-[80px] lg:mt-[140px]">
            
            <div className="w-full xl:w-[650px] lg:text-center text-white text-[20px] leading-normal xl:text-[32px] xl:leading-[44.8px] font-bold font-['Open Sans'] px-4 lg:px-0">
              600+ поддерживаемых технологий
            </div>
            <div className="w-full lg:w-[458px] h-auto xl:h-[46px] lg:text-center text-white text-[16px] lg:text-base font-semibold font-['Open Sans'] px-4 lg:px-0">
              Мы постоянно развиваемся и внедряем новые технологии в свои продукты<br /><br />
            </div>
            <a href="/supported-technologies" className="w-full max-w-[310px] md:w-[195px] h-[45px] bg-white/20 rounded-[20px] border border-white text-center flex justify-center">
              <div className="text-white w-[195px] h-[45px] text-xl font-bold font-['Open Sans'] justify-center items-center flex">Подробнее</div>
            </a>
          </div>
        </div>


      </div>
    </div>
  );
};
